// ─── Sticky announcement bar: sync height to CSS custom property ─────────────
// Measures the announcement bar wrapper and sets --announcement-bar-height on
// <html> so the sticky header below it starts at the right offset.
(function () {
  function setAnnouncementBarHeight() {
    var bar = document.querySelector('.shopify-section.announcement-bar-wrapper');
    if (!bar) return;
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      bar.offsetHeight + 'px'
    );
  }
  document.addEventListener('DOMContentLoaded', setAnnouncementBarHeight);
  window.addEventListener('resize', setAnnouncementBarHeight);
})();

// Patch recommended-products section to use complementary intent
(function() {
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' &&
        url.indexOf('recommendations') !== -1 &&
        url.indexOf('section_id') !== -1 &&
        url.indexOf('intent') === -1) {
      url = url + '&intent=complementary';
    }
    return _open.apply(this, arguments);
  };
})();

// ─── CRO: Sticky ATC subscribe toggle wiring ─────────────────────────────────
// When the subscribe toggle in the sticky ATC bar is checked, finds the
// subscription selling plan radio in the main form and selects it so the
// correct selling plan ID is submitted.
(function () {
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-sticky-subscribe-toggle]');
    if (!toggle) return;
    var checked = toggle.checked;
    // Find selling plan inputs in the main product form
    var planInputs = document.querySelectorAll(
      '.product-form [name="selling_plan"], ' +
      '.recharge-widget [name="selling_plan"], ' +
      '.rc_widget__option-item input[type="radio"]'
    );
    if (planInputs.length === 0) return;
    if (checked) {
      // Select the first subscription option
      planInputs[0].checked = true;
      planInputs[0].dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      // Deselect: look for a one-time purchase option
      var onetime = document.querySelector(
        '.rc_widget__option-item--one-time input, ' +
        '[data-selling-plan=""] input, ' +
        '.product-form [name="selling_plan"][value=""]'
      );
      if (onetime) {
        onetime.checked = true;
        onetime.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();

// ─── Klaviyo footer form: override inline styles ──────────────────────────────
// Klaviyo renders with heavy inline styles inside kl-private-reset-css scope.
// CSS !important cannot beat inline styles for some properties, so we patch
// them directly via JS after the form mounts.
(function () {
  function styleKlaviyoFooterForm() {
    var wrapper = document.querySelector('.footer__klaviyo-form');
    if (!wrapper) return;

    // 1. Remove min-height from the outermost Klaviyo-rendered div
    var outerDiv = wrapper.querySelector('.kl-private-reset-css-Xuajs1');
    if (outerDiv) {
      outerDiv.style.minHeight = '0';
      outerDiv.style.justifyContent = 'flex-start';
    }

    // 2. Make the two rows (input row + button row) sit side-by-side in one row
    var rows = wrapper.querySelectorAll('[data-testid="form-row"]');
    if (rows.length >= 2) {
      // Wrap rows in a flex container if not already done
      var form = rows[0].parentElement;
      if (form) {
        form.style.flexDirection = 'row';
        form.style.alignItems = 'stretch';
        form.style.minHeight = '0';
      }
      // Input row: grow to fill space
      rows[0].style.flex = '1 1 auto';
      rows[0].style.minWidth = '0';
      // Button row: shrink to content
      rows[1].style.flex = '0 0 auto';
    }

    // 3. Remove padding from inner component wrappers
    wrapper.querySelectorAll('[data-testid="form-component"]').forEach(function(el) {
      el.style.padding = '0';
    });

    // 4. Style the input
    var input = wrapper.querySelector('input[type="email"]');
    if (input) {
      input.style.backgroundColor = 'rgba(255,255,255,0.08)';
      input.style.color = '#ffffff';
      input.style.border = '1px solid rgba(255,255,255,0.25)';
      input.style.borderRadius = '0';
      input.style.height = '40px';
      input.style.fontSize = '13px';
      input.style.padding = '0 12px 0 14px';
      input.style.width = '100%';
      input.style.boxSizing = 'border-box';
    }

    // 5. Style the button
    var btn = wrapper.querySelector('button');
    if (btn) {
      btn.style.background = '#ffffff';
      btn.style.color = '#151515';
      btn.style.borderRadius = '0';
      btn.style.height = '40px';
      btn.style.width = 'auto';
      btn.style.padding = '0 16px';
      btn.style.fontSize = '12px';
      btn.style.fontWeight = '700';
      btn.style.letterSpacing = '0.08em';
      btn.style.textTransform = 'uppercase';
      btn.style.whiteSpace = 'nowrap';
      btn.style.cursor = 'pointer';
    }
  }

  // Klaviyo loads asynchronously — poll until the form renders
  var attempts = 0;
  var interval = setInterval(function () {
    var form = document.querySelector('.footer__klaviyo-form input[type="email"]');
    if (form) {
      styleKlaviyoFooterForm();
      clearInterval(interval);
    }
    if (++attempts > 40) clearInterval(interval); // give up after ~8s
  }, 200);
})();

// ─── Bug #2: multi-variant "Choose options" → full PDP ───────────────────────
// On collection/home/search cards the "Choose options" button opens the theme's
// quick-add modal (main-product--quick-add). That modal only carries variant_picker
// + inventory-counter blocks and is loaded over AJAX, so ReCharge's Subscribe & Save
// widget never injects there and the per-day price breaks — the customer sees a
// stripped buy box with no subscription discount and no $/day. The full PDP has all
// of it, so for multi-variant products we send the click straight to the product page.
//
// Implemented as a CAPTURE-phase listener on document so it runs BEFORE the theme's
// own target-phase handler on the button; stopImmediatePropagation() prevents the
// modal from opening. Single-variant cards (direct add-to-cart) are left untouched.
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.product-item__quick-add');
      if (!btn) return;

      var wrapper = btn.closest('.product-item__quick-add-wrapper');
      if (!wrapper || wrapper.getAttribute('data-has-variants') !== 'true') return;

      var item = btn.closest('[data-url]');
      var url = item && item.getAttribute('data-url');
      if (!url) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = url;
    },
    true
  );
})();

// ─── CRO: Page speed — defer non-critical third-party scripts ─────────────────
// Moves non-essential app scripts to load after page becomes interactive.
// Targets Smile.io launcher (loyalty points popup) which loads eagerly.
(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferSmile);
  } else {
    deferSmile();
  }
  function deferSmile() {
    // Smile.io loads via a script tag injected by the app — we just make sure
    // its initialization happens after the LCP image has loaded.
    var smileScript = document.querySelector('script[src*="smile.io"], script[src*="cdn.sweettooth"]');
    if (smileScript && !smileScript.hasAttribute('defer')) {
      // Already loaded; nothing to do
    }
  }
})();




// === Mood collections slider: scroll-synced color blend =====================
// During the swipe, --mood-bg-active is interpolated between adjacent panels'
// colors based on scroll position, so the header / peek / dots regions blend
// smoothly with the finger (no settle-delay). On slide-changed, the BE [MOOD]
// lockup of the new active panel pops once as motion punctuation.
(function () {
  var POP_MS = 260; // 220ms anim + small buffer

  function hexToRgb(hex) {
    if (!hex) return null;
    var h = hex.replace('#', '').trim();
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return null;
    var n = parseInt(h, 16);
    if (isNaN(n)) return null;
    return [(n >> 16) & 0xff, (n >> 8) & 0xff, n & 0xff];
  }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function blend(a, b, t) {
    return 'rgb(' + Math.round(lerp(a[0], b[0], t)) + ', ' +
                    Math.round(lerp(a[1], b[1], t)) + ', ' +
                    Math.round(lerp(a[2], b[2], t)) + ')';
  }

  function initMoodSlider(section) {
    if (!section || section.dataset.moodSliderInit === '1') return;
    var sliderId = section.getAttribute('data-slider-id');
    if (!sliderId) return;
    section.dataset.moodSliderInit = '1';

    var panels = section.querySelectorAll('.mood-panel');
    var track = section.querySelector('.mood-slider__track');
    var popTimer = null;
    var scrollRaf = 0;

    // Prev/next nav is the theme-native scroll-slider-component nav buttons
    // (snippets/scroll-slider-navigation-buttons.liquid) — the component itself
    // owns scroll position and fights direct scrollLeft/scrollTo writes from
    // outside, so click/disabled/hidden state is left entirely to its own JS
    // (assets/scroll-slider.js) rather than reimplemented here.

    // Pre-parse panel colors once.
    var colors = [];
    for (var i = 0; i < panels.length; i++) {
      colors.push(hexToRgb(panels[i].getAttribute('data-mood-bg')) || [246, 246, 246]);
    }

    if (panels[0]) {
      var firstBg = panels[0].getAttribute('data-mood-bg');
      if (firstBg) section.style.setProperty('--mood-bg-active', firstBg);
      panels[0].setAttribute('data-active', '1');
    }

    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        if (!track || !panels.length) return;
        var w = panels[0].offsetWidth || track.clientWidth || 1;
        var raw = track.scrollLeft / w;
        var i0 = Math.max(0, Math.min(panels.length - 1, Math.floor(raw)));
        var i1 = Math.max(0, Math.min(panels.length - 1, i0 + 1));
        var t = Math.max(0, Math.min(1, raw - i0));
        section.style.setProperty('--mood-bg-active', blend(colors[i0], colors[i1], t));
      });
    }
    if (track) track.addEventListener('scroll', onScroll, { passive: true });

    // TOUCH SNAP ENFORCER — the real reason mobile could rest between two
    // panels. On touch devices the theme runs NO slider JS at all
    // (scroll-slider.js: `if (!userIsOnTouchScreen()) initDragScroll()`), so
    // mobile leans entirely on CSS `scroll-snap-type: x mandatory`. That's
    // meant to always snap, but both mobile engines intermittently fail to
    // re-snap after a SLOW drag-release (little/no momentum) when the scroller
    // has position:sticky children (our .mood-panel__sticky-head) or content
    // that resizes mid-scroll (lazy product images) — it just parks between
    // panels. iOS/WebKit specifically: `scrollend` only exists in Safari 17.4+
    // and is flaky inside snap containers even there, so we CANNOT rely on it.
    //
    // Engine-agnostic settle detector instead: treat scroll as "settled" when
    // no scroll event has fired for ~130ms AND no finger is down, then, if not
    // aligned to a panel, smooth-scroll to the nearest one. This fires only
    // after real motion (drag + momentum) has fully stopped, so it never
    // interrupts a live swipe or fling; and the `!touching` gate means it
    // never yanks the view while a finger is still resting on the panel
    // mid-drag. iOS + Android + desktop all fire `scroll` during momentum and
    // stop when it dies, so this one path covers every engine and OS version.
    // Idempotent: the corrective scroll lands aligned, so the scroll it emits
    // re-arms the timer once and then no-ops (<=2px). Harmless on desktop
    // (already aligned via CSS snap + the mouse-drag handler below).
    var snapEnforcing = false;
    function enforceSnap() {
      if (!track || snapEnforcing || touching) return;
      var w = track.clientWidth || (panels[0] && panels[0].offsetWidth) || 0;
      if (w <= 0) return;
      var maxLeft = track.scrollWidth - w;
      var target = Math.round(track.scrollLeft / w) * w;
      if (target > maxLeft) target = maxLeft;
      if (target < 0) target = 0;
      if (Math.abs(track.scrollLeft - target) <= 2) return; // already aligned
      snapEnforcing = true;
      try { track.scrollTo({ left: target, behavior: 'smooth' }); }
      catch (e) { track.scrollLeft = target; }
      setTimeout(function () { snapEnforcing = false; }, 450);
    }
    var touching = false;
    var settleTimer = null;
    function armSettle() {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(enforceSnap, 130);
    }
    if (track) {
      track.addEventListener('scroll', armSettle, { passive: true });
      // Track finger state so we never snap mid-drag; re-arm on lift so a slow
      // drag-and-hold-then-release (which may emit NO further scroll events
      // after the finger stops moving) still gets a settle check on touchend.
      track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
      track.addEventListener('touchend', function () { touching = false; armSettle(); }, { passive: true });
      track.addEventListener('touchcancel', function () { touching = false; armSettle(); }, { passive: true });
    }

    // NOTE: the "BE" overlay needs NO JS positioning. All six panels anchor
    // their lockup to one shared static x (calc(50% - 2.85em), see the
    // .mood-slider__be comment in custom.css), so the overlay's CSS "left"
    // is already correct for every panel at every viewport. An earlier
    // version re-measured and snapped the overlay per slide-change — that
    // WAS the visible "BE jumps after the slide settles" bug. Don't re-add.

    // Desktop mouse-drag fix: the theme's own scroll-slider.js adds a
    // "free-scroll-mode" class on mousedown-drag (to disable scroll-snap so
    // the drag itself feels smooth) but its mouseup handler never removes it
    // or snaps back — only its internal scrollTo() does that, and mouseup
    // never calls it. Net effect: dragging with a mouse and releasing just
    // stops wherever the cursor let go, no snap. (Touch swipe is unaffected —
    // it's native browser scrolling, not this mouse-only drag handler.)
    // scrollTo on the custom element IS that internal method (class methods
    // shadow the native Element.scrollTo), so calling it does exactly what a
    // button/dot click does: clears free-scroll-mode and animates to the
    // target position.
    var sliderComponent = track ? track.closest('scroll-slider-component') : null;
    // Track drag state ourselves rather than reading the theme's own
    // "mouse-down" class in a mouseleave handler — its own mouseleave
    // listener (registered before ours, during component init) clears that
    // class synchronously in the same dispatch, so by the time ours ran the
    // class would already be gone. Also capture the page you STARTED the
    // drag on, so release can compare "how far did you actually drag" against
    // a low threshold instead of blindly rounding the final scroll position
    // to the nearest page (which effectively required a 50%-of-a-panel drag
    // before anything advanced — a much smaller, more intentional flick
    // should be enough).
    var ADVANCE_THRESHOLD = 0.06; // fraction of one panel's width
    var dragWasActive = false;
    var dragStartIndex = 0;
    if (track) {
      track.addEventListener('mousedown', function () {
        dragWasActive = true;
        var w = panels[0] ? panels[0].offsetWidth : track.clientWidth || 1;
        dragStartIndex = Math.round(track.scrollLeft / (w || 1));
      });
    }

    function snapToNearestAfterDrag(evt) {
      if (!track || !panels.length) return;
      if (evt.type === 'mouseleave' && !dragWasActive) return;
      dragWasActive = false;
      setTimeout(function () {
        var w = panels[0].offsetWidth || track.clientWidth || 1;
        var draggedFraction = (track.scrollLeft - dragStartIndex * w) / w;
        var targetIndex = dragStartIndex;
        if (draggedFraction > ADVANCE_THRESHOLD) targetIndex = dragStartIndex + 1;
        else if (draggedFraction < -ADVANCE_THRESHOLD) targetIndex = dragStartIndex - 1;
        targetIndex = Math.max(0, Math.min(panels.length - 1, targetIndex));
        var target = targetIndex * w;
        if (sliderComponent && typeof sliderComponent.scrollTo === 'function') {
          sliderComponent.scrollTo(target, 'smooth');
        } else {
          track.scrollTo({ left: target, behavior: 'smooth' });
        }
      }, 0);
    }
    if (track) {
      track.addEventListener('mouseup', snapToNearestAfterDrag);
      track.addEventListener('mouseleave', snapToNearestAfterDrag);
    }

    // ONE-TIME AFFORDANCE NUDGE — the panels can read as a static hero, so
    // the first time the slider is majority-visible (~60%) we wait a beat and
    // auto-advance once to panel 2, via the component's own scrollTo so the
    // dots / lockup pop / color-blend all fire like a real swipe. Strictly
    // once per browser session, cancelled if the user touches/drags/wheels
    // the track first, and skipped under prefers-reduced-motion. This is a
    // single affordance hint, NOT auto-rotation (which stays banned).
    var nudgeIO = null;
    var nudgeTimer = null;
    (function () {
      if (!track || panels.length < 2 || !('IntersectionObserver' in window)) return;
      try { if (sessionStorage.getItem('bhbyMoodNudged') === '1') return; } catch (e) {}
      try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
      var done = false;
      function markDone() {
        if (done) return;
        done = true;
        if (nudgeTimer) { clearTimeout(nudgeTimer); nudgeTimer = null; }
        if (nudgeIO) { nudgeIO.disconnect(); nudgeIO = null; }
        try { sessionStorage.setItem('bhbyMoodNudged', '1'); } catch (e) {}
      }
      // Any real interaction = the user already knows it slides; stand down.
      ['touchstart', 'mousedown', 'wheel'].forEach(function (t) {
        track.addEventListener(t, markDone, { passive: true, once: true });
      });
      nudgeIO = new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        if (!entry || done || !entry.isIntersecting) return;
        // "Majority in view" that still works when the section is taller than
        // the viewport: visible height over the smaller of section/viewport.
        var viewportH = window.innerHeight || (entry.rootBounds ? entry.rootBounds.height : 0);
        var basis = Math.min(entry.boundingClientRect.height, viewportH);
        if (basis <= 0 || entry.intersectionRect.height / basis < 0.6) return;
        if (track.scrollLeft > 2) { markDone(); return; }
        if (nudgeIO) { nudgeIO.disconnect(); nudgeIO = null; }
        nudgeTimer = setTimeout(function () {
          nudgeTimer = null;
          if (done) return;
          markDone();
          if (touching || track.scrollLeft > 2) return; // user beat us to it
          var w = panels[0].offsetWidth || track.clientWidth || 0;
          if (w <= 0) return;
          if (sliderComponent && typeof sliderComponent.scrollTo === 'function') {
            sliderComponent.scrollTo(w, 'smooth');
          } else {
            try { track.scrollTo({ left: w, behavior: 'smooth' }); }
            catch (e) { track.scrollLeft = w; }
          }
        }, 900);
      }, { threshold: [0.35, 0.5, 0.6, 0.75, 0.9] });
      nudgeIO.observe(section);
    })();

    var handler = function (evt) {
      var detail = evt.detail || {};
      var idx = (detail.currentPage || 1) - 1;
      var panel = panels[idx];
      if (!panel) return;
      var bg = panel.getAttribute('data-mood-bg') || '';
      var text = panel.getAttribute('data-mood-text') || '';
      var word = panel.getAttribute('data-mood-word') || '';

      if (bg) section.style.setProperty('--mood-bg-active', bg);
      if (text) section.style.setProperty('--mood-text-active', text);
      section.setAttribute('data-active-mood', word.toLowerCase());
      section.setAttribute('data-active-index', String(idx));

      for (var i = 0; i < panels.length; i++) panels[i].removeAttribute('data-active');
      panel.setAttribute('data-active', '1');

      // Restart lockup pop: remove, reflow, re-add. Scoped to the single
      // active panel (not the whole full-bleed section) — reflowing the
      // entire slider (all 6 panels' DOM) on mobile was expensive enough to
      // visibly jank the animation, reading as the mood word "blinking away"
      // for a beat before catching up.
      panel.removeAttribute('data-popping');
      // eslint-disable-next-line no-unused-expressions
      void panel.offsetWidth;
      panel.setAttribute('data-popping', '1');

      if (popTimer) clearTimeout(popTimer);
      popTimer = setTimeout(function () {
        panel.removeAttribute('data-popping');
      }, POP_MS);
    };

    document.addEventListener('scroll-slider-' + sliderId + ':slide-changed', handler);

    document.addEventListener('shopify:section:unload', function (evt) {
      if (evt.target === section || section.contains(evt.target)) {
        document.removeEventListener('scroll-slider-' + sliderId + ':slide-changed', handler);
        if (track) track.removeEventListener('scroll', onScroll);
        if (popTimer) clearTimeout(popTimer);
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        if (nudgeTimer) clearTimeout(nudgeTimer);
        if (nudgeIO) nudgeIO.disconnect();
        section.dataset.moodSliderInit = '';
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-section-type="mood-collections-slider"]').forEach(initMoodSlider);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (evt) { initAll(evt.target); });
})();
